import { create } from "zustand";

interface AccentColorState {
  accentColor: string;
  setAccentColor: (color: string) => void;
}

export const useAccentColorStore = create<AccentColorState>((set) => ({
  accentColor: "#2563eb", // cor padrão (azul)
  setAccentColor: (color) => set({ accentColor: color }),
}));